<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    getMenu() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/accounts/menu`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    saveMenu(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/accounts/menu`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    }
  }
}
</script>